import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon } from 'lucide-react';
export const ContactSection = () => {
  return <section className="py-20 bg-[#f2f2ed] w-full" data-id="element-304">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-305">
        <div className="mb-16" data-id="element-306">
          <h6 className="text-sm uppercase tracking-wider text-[#3a4a56] font-medium mb-6" data-id="element-307">
            Contact
          </h6>
          <h2 className="text-4xl md:text-5xl font-normal text-[#3a4a56] leading-tight mb-10" data-id="element-308">
            Ready to find your dream home? Our luxury real estate experts are
            here to help.
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-309">
          <div className="p-8 border-b border-[#3a4a56]" data-id="element-310">
            <div className="flex items-center mb-6" data-id="element-311">
              <PhoneIcon className="h-8 w-8 text-[#00A3E0] mr-4" data-id="element-312" />
              <h3 className="text-xl font-normal text-[#3a4a56]" data-id="element-313">Call Us</h3>
            </div>
            <p className="text-[#3a4a56] mb-2" data-id="element-314">Mobile:</p>
            <p className="text-[#3a4a56] text-lg mb-4" data-id="element-315">514.659.8161</p>
          </div>
          <div className="p-8 border-b border-[#3a4a56]" data-id="element-316">
            <div className="flex items-center mb-6" data-id="element-317">
              <MailIcon className="h-8 w-8 text-[#00A3E0] mr-4" data-id="element-318" />
              <h3 className="text-xl font-normal text-[#3a4a56]" data-id="element-319">Email Us</h3>
            </div>
            <p className="text-[#3a4a56] mb-2" data-id="element-320">For inquiries:</p>
            <p className="text-[#3a4a56] font-medium text-lg mb-4" data-id="element-321">
              info@immovendu.com
            </p>
          </div>
          <div className="p-8 border-b border-[#3a4a56]" data-id="element-322">
            <div className="flex items-center mb-6" data-id="element-323">
              <MapPinIcon className="h-8 w-8 text-[#00A3E0] mr-4" data-id="element-324" />
              <h3 className="text-xl font-normal text-[#3a4a56]" data-id="element-325">Visit Us</h3>
            </div>
            <p className="text-[#3a4a56] mb-2" data-id="element-326">Royal LePage du Quartier</p>
            <p className="text-[#3a4a56] font-medium text-lg mb-4" data-id="element-327">
              6971 Ch. Côte-de-Liesse, #C
              <br data-id="element-328" />
              Montréal (St-Laurent), QC
              <br data-id="element-329" />
              H4T 1Z3
            </p>
          </div>
        </div>
        <div className="mt-12 p-8 border-b border-[#3a4a56]" data-id="element-330">
          <div className="flex items-center mb-6" data-id="element-331">
            <ClockIcon className="h-8 w-8 text-[#00A3E0] mr-4" data-id="element-332" />
            <h3 className="text-xl font-normal text-[#3a4a56]" data-id="element-333">
              Business Hours
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-334">
            <div data-id="element-335">
              <p className="text-[#3a4a56] mb-1" data-id="element-336">Monday - Friday:</p>
              <p className="text-[#3a4a56] font-medium" data-id="element-337">9:00 AM - 6:00 PM</p>
            </div>
            <div data-id="element-338">
              <p className="text-[#3a4a56] mb-1" data-id="element-339">Saturday:</p>
              <p className="text-[#3a4a56] font-medium" data-id="element-340">10:00 AM - 4:00 PM</p>
            </div>
            <div data-id="element-341">
              <p className="text-[#3a4a56] mb-1" data-id="element-342">Sunday:</p>
              <p className="text-[#3a4a56] font-medium" data-id="element-343">Closed</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};